/**
 * WHATSAPP SESSION MAPPERS — conversione tra tipo UI e DTO REST. Sola lettura: il
 * DTO REST (`WhatsAppSession`) porta i messaggi annidati, mappati col mapper del
 * messaggio.
 */

import { pickAuditFields } from '@crm/shared';
import {
  whatsAppMessageFromDto,
  type WhatsAppMessageDto,
} from '../whatsAppMessage/whatsAppMessageMappers';
import type { WhatsAppWindowState } from '../whatsAppMessage/whatsAppMessageTypes';
import type { WhatsAppSession } from './whatsAppSessionTypes';

/**
 * Shape del WhatsAppSession come esce dal REST
 * (/o/crm/v1_0/whatsapp-sessions/{groupId}/{personId}). Rispecchia lo schema
 * WhatsAppSession nel rest-openapi.yaml.
 */
export interface WhatsAppSessionDto {
  whatsAppSessionId: number;
  companyId: number;
  groupId: number;
  userId: number;
  userName: string;
  createDate: string;
  modifiedDate: string;
  phoneNumber?: string;
  phoneNumberId?: string;
  personId?: number;
  startDate?: string;
  lastMessageDate?: string;
  messageCount?: number;
  windowState?: string;
  windowExpirationDate?: string;
  messages?: WhatsAppMessageDto[];
}

/** DTO -> modello UI. */
export function whatsAppSessionFromDto(dto: WhatsAppSessionDto): WhatsAppSession {
  return {
    whatsAppSessionId: dto.whatsAppSessionId,
    ...pickAuditFields(dto),
    phoneNumber: dto.phoneNumber ?? '',
    phoneNumberId: dto.phoneNumberId ?? '',
    personId: dto.personId ?? 0,
    startDate: dto.startDate ?? '',
    lastMessageDate: dto.lastMessageDate ?? '',
    messageCount: dto.messageCount ?? 0,
    // Fallback CLOSED e non OPEN: se il backend non dicesse nulla, meglio
    // impedire un invio che Meta rifiuterebbe che permetterne uno che si perde.
    windowState: (dto.windowState as WhatsAppWindowState) ?? 'CLOSED',
    windowExpirationDate: dto.windowExpirationDate ?? undefined,
    messages: (dto.messages ?? []).map(whatsAppMessageFromDto),
  };
}
